export default __webpack_public_path__ + "static/media/jerserystore.e01f1743.svg";